import Vue from 'vue';
import visibleTrack from './v-visible-track';
import clickTrack from './v-click-track';

Vue.directive('visible-track', visibleTrack);
Vue.directive('click-track', clickTrack);
